module.exports = __webpack_public_path__ + "img/Menu-08.6dd0e8c0.png";